var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 200,
    viewBox: "0 0 269 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.2703,
    y: 110.409,
    width: 12.2123,
    height: 21.8076,
    transform: "rotate(45 96.2703 110.409)",
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.287 121.693C82.068 120.912 83.3343 120.912 84.1154 121.693L93.6232 131.201C94.4043 131.982 94.4043 133.248 93.6232 134.029L68.0032 159.649C64.879 162.773 59.8137 162.773 56.6895 159.649L55.6669 158.626C52.5427 155.502 52.5427 150.437 55.6669 147.313L81.287 121.693Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.037 120.279C117.18 142.421 153.08 142.421 175.223 120.279C197.365 98.1359 197.365 62.2355 175.223 40.0928C153.08 17.9502 117.18 17.9502 95.037 40.0928C72.8944 62.2355 72.8944 98.1359 95.037 120.279ZM102.439 112.877C120.494 130.932 149.766 130.932 167.821 112.877C185.876 94.822 185.876 65.5494 167.821 47.4946C149.766 29.4398 120.494 29.4398 102.439 47.4946C84.384 65.5494 84.384 94.822 102.439 112.877Z",
    fill: "#3D3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.609 36.6368L256.841 36.6368",
    stroke: "#5DCCC6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4441 63.6783L20.4458 63.6783",
    stroke: "#5DCCC6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.449 51.466H229.363",
    stroke: "#5DCCC6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4011 48.8491L47.4874 48.8491",
    stroke: "#5DCCC6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9138 76.7628L3.00006 76.7628",
    stroke: "#5DCCC6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.449 66.2952H245.937",
    stroke: "#5DCCC6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6785 34.0199L30.914 34.0199",
    stroke: "#5DCCC6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M253.787 66.2952H266",
    stroke: "#5DCCC6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0632 34.0199L10.851 34.0199",
    stroke: "#5DCCC6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.845 58.4766L157.484 102.116",
    stroke: "#F3576C",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.484 58.4766L113.845 102.116",
    stroke: "#F3576C",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotFound);
export default __webpack_public_path__ + "static/media/errorNotFound.18e1fbe9b6932098afffd23f5f8dbb84.svg";
export { ForwardRef as ReactComponent };